var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceholderBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62.246mm",
    height: "18.674mm",
    viewBox: "0 0 62.246 18.674",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24.009 -53.946)",
    strokeWidth: 0.26458
  }, /*#__PURE__*/React.createElement("text", {
    x: 26.380239,
    y: 65.802391,
    fill: "#000000",
    fontSize: "12.7px",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 26.380239,
    y: 65.802391,
    strokeWidth: 0.26458,
    fontFamily: "'SF Pro Display'",
    fontWeight: "bold"
  }, "Test", /*#__PURE__*/React.createElement("tspan", {
    fill: "#4d65f1",
    fontFamily: "'SF Pro Display'",
    fontSize: "12.7px",
    fontWeight: "bold"
  }, "B"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#1129cd",
    fontFamily: "'SF Pro Display'",
    fontSize: "12.7px",
    fontWeight: "bold"
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#0d1e94",
    fontFamily: "'SF Pro Display'",
    fontSize: "12.7px",
    fontWeight: "bold"
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#071050",
    fontFamily: "'SF Pro Display'",
    fontSize: "12.7px",
    fontWeight: "bold"
  }, "k"))), /*#__PURE__*/React.createElement("text", {
    x: 58.32933,
    y: 69.410515,
    fill: "#071050",
    fontFamily: "'SF Pro Display'",
    fontSize: "3.8806px",
    fontWeight: "bold",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 58.32933,
    y: 69.410515,
    fontSize: "3.8806px",
    strokeWidth: 0.26458
  }, "Placeholder")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderBank);
export default __webpack_public_path__ + "static/media/placeholderBank.8501252f578e19dbd8c6a12132df4114.svg";
export { ForwardRef as ReactComponent };